import { useContext, useEffect } from 'react'
import useMediaSelectionActions from '../actions/useMediaSelectionActions'
import { UserContext, UserContextType } from '../UserContext'

export default function useSystemAudioOutputChangeConfirmationController() {
    const { state, dispatch } = useContext(UserContext) as UserContextType

    const { checkMuseAudioShareOutputMatch } = useMediaSelectionActions()

    useEffect(() => {
        const gldev = state.mediaSelection.globalOutputDevice
        const selectedAudioInputs = state.mediaSelection.audioInputs

        const isOk = checkMuseAudioShareOutputMatch(selectedAudioInputs, gldev)

        if (isOk != null) {
            dispatch({
                type: 'update_media_selection',
                value: {
                    showSystemAudioOutputChangeConfirmation: !isOk,
                },
            })
        }
    }, [state.mediaSelection.audioInputs, state.mediaSelection.globalOutputDevice])
}
